module.exports = __webpack_public_path__ + "img/taocanyuliang.99b69144.svg";